/**
 * Onboarding step 2 — Choose modules. Multi-select glass cards; the
 * selection is persisted as a Company Brain fact on activation (nav
 * highlighting is deliberately out of scope).
 */

import { Check } from 'lucide-react';
import { MODULES, type ModuleKey, type OnboardingDraft } from '../../../lib/onboarding';

interface Props {
  draft: OnboardingDraft;
  onPatch: (patch: Partial<OnboardingDraft>) => void;
}

export function StepModules({ draft, onPatch }: Props) {
  const toggle = (key: ModuleKey) => {
    const on = draft.modules.includes(key);
    onPatch({
      modules: on ? draft.modules.filter((k) => k !== key) : [...draft.modules, key],
    });
  };

  return (
    <div className="onb-step">
      <h3 className="t-section-title onb-step__title">Choose your modules</h3>
      <p className="t-meta onb-step__blurb">
        Pick what you plan to run in Argo. Everything stays available — this just
        tells the Brain where to focus first.
      </p>
      <div className="onb-card-grid">
        {MODULES.map((m) => {
          const selected = draft.modules.includes(m.key);
          return (
            <button
              key={m.key}
              type="button"
              className="onb-card"
              aria-pressed={selected}
              onClick={() => toggle(m.key)}
            >
              <span className="onb-card__check" aria-hidden="true">
                {selected && <Check size={12} />}
              </span>
              <span className="onb-card__label">{m.label}</span>
              <span className="t-meta onb-card__blurb">{m.blurb}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
